import React, { useState } from 'react'

import { questionModel } from '../../Interfaces/questionModel';
import { useNavigate } from 'react-router-dom';

import apiResponse from '../../Interfaces/apiResponse';
import { toast } from 'react-toastify';
import { useDeleteQuestionMutation } from '../../API/QuestionApi';
import ImageSrc from '../../Helper/ImageSrc';
interface props{
    questionChoiceData:questionModel[]
}
function QuestionQueryTable({questionChoiceData}:props) {
    //console.log(questionChoiceData);
    const[loading, setLoading] = useState(false);
    const [expandedRows, setExpandedRows] = useState<number[]>([]);
    const navigate =useNavigate();
    const toggleRow = (id: number) => {
      setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id]
    );
  };
   const handleUpdate = async (dataQuestion:questionModel) => {
       navigate("/questions/update",{ state: { dataQuestion } });
    }
    const [deleteQuestion] = useDeleteQuestionMutation();
    const handleDelete = async (id:number) => {
        setLoading(true);
         try {
          const response:apiResponse = await deleteQuestion(id);
          
           if(response.data?.isSuccess == true){
                   toast.success('Deleted Successfully!', {
                       position: "top-right", 
                       autoClose: 5000, 
                     });
               navigate("/questions/list");
               }else if(response.data?.exist == true){
                 toast.error('Question already exist!', {
                   position: "top-right", 
                   autoClose: 5000, 
                 });
               }
               else{
                 toast.error('Something went wrong!', {
                     position: "top-right", 
                     autoClose: 5000, 
                   });
               }
             
           } catch (error) {
             console.error('Error:', error);
            
           } finally {
             setLoading(false);
           }
       
    }
    
  return (
      <div>
          <table className="table table-striped table-hover align-middle">
              <thead className="thead-light text-nowrap">
                  <tr>
                    <th>Actions</th>
                    <th>Question</th>
                    <th style={{ width: "40px" }}>Choices</th>
                    <th>Category</th>
                    <th>Level</th>
                    <th>Answer</th>
                  </tr>
              </thead>

              <tbody className="position-relative">
                  {questionChoiceData.map((rowData) => (
                      <React.Fragment key={rowData.id}>
                          {/* Question Row */}
                          <tr>
                              <td> <a className="me-2" style={{cursor:'pointer'}} 
                                onClick={() => handleUpdate(rowData)}>
                                <i className="bi bi-pencil-square"></i></a> 
                                 <a style={{cursor:'pointer'}} 
                                onClick={() => handleDelete(rowData.id)}>
                                <i className="bi bi-trash"></i></a> 
                                </td>
                              <td>{rowData?.questionText}
                                {rowData.questionImageUrl && (
                                    ImageSrc(rowData.questionImageUrl)
                                    //<img src={`https://localhost:44383${rowData.questionImageUrl}`} alt="Question" width="200" />
                                )}
                              </td>
                              <td className="text-center">
                                  <button
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={() => toggleRow(rowData.id)}
                                  >
                                      {expandedRows.includes(rowData.id) ? (
                                          <i className="bi bi-chevron-up"></i>
                                      ) : (
                                          <i className="bi bi-chevron-down"></i>
                                      )}
                                  </button>
                              </td>
                              <td>{rowData?.category?.name}</td>
                              <td>{rowData?.level?.levelName}</td>
                              <td>{rowData?.answerKey}
                                 {rowData.answerKeyImageUrl && (
                                    ImageSrc(rowData.answerKeyImageUrl)
                                )}
                              </td>
                          </tr>

                          {/* Collapsible Row */}
                          {expandedRows.includes(rowData.id) && rowData.choice && (
                              <tr className="bg-light">
                                  <td></td>
                                  <td colSpan={3}>
                                      <div className="p-2">
                                          <ul className="list-unstyled mb-0">
                                              <li>
                                                  <strong>A:</strong> {rowData.choice.a}
                                                    {rowData.choice.choiceAImageUrl && (
                                                        ImageSrc(rowData.choice.choiceAImageUrl)
                                                    )}
                                              </li>
                                              <li>
                                                  <strong>B:</strong> {rowData.choice.b}
                                                   {rowData.choice.choiceBImageUrl && (
                                                        ImageSrc(rowData.choice.choiceBImageUrl)
                                                    )}
                                              </li>
                                              <li>
                                                  <strong>C:</strong> {rowData.choice.c}
                                                   {rowData.choice.choiceCImageUrl && (
                                                        ImageSrc(rowData.choice.choiceCImageUrl)
                                                    )}
                                              </li>
                                              {rowData.choice.d && (
                                                  <li>
                                                      <strong>D:</strong> {rowData.choice.d}
                                                     
                                                  </li>
                                              )}
                                                {rowData.choice.choiceDImageUrl && (
                                                    <li>
                                                         <strong>D:</strong>
                                                        {ImageSrc(rowData.choice.choiceDImageUrl)}
                                                    </li>
                                                )}
                                              {rowData.choice.e && (
                                                  <li>
                                                      <strong>E:</strong> {rowData.choice.e}
                                                       {rowData.choice.choiceEImageUrl && (
                                                        ImageSrc(rowData.choice.choiceEImageUrl)
                                                    )}
                                                  </li>
                                              )}
                                               {rowData.choice.choiceEImageUrl && (
                                                    <li>
                                                         <strong>E:</strong>
                                                          {ImageSrc(rowData.choice.choiceEImageUrl)}
                                                    </li>
                                                )}
                                          </ul>
                                      </div>
                                  </td>
                              </tr>
                          )}
                      </React.Fragment>
                  ))}
              </tbody>
          </table>
      </div>
  )
}

export default QuestionQueryTable